/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Aggregate counters for the Enrollments tab KPI cards.
 *
 * Computed across the WHOLE sequence (org-scoped), not just the visible
 * page — so the cards reflect the true totals regardless of pagination.
 *
 * Every counter is a UNIQUE-CANDIDATE head count, so a candidate who
 * holds several enrollments in this sequence (at most one live, plus the
 * terminal rows earlier attempts left behind) is counted once. ``total``
 * is the number of distinct candidates and every other field is
 * ``<= total``, which is what lets the cards render a "% of total" that
 * can never exceed 100%.
 *
 * ``completed`` means EVERY one of that candidate's enrollments reached a
 * final state (completed / cancelled / bounced / error); a single live row
 * — including ``paused`` — keeps them out of it. See
 * ``app.services.outreach.enrollment_analytics`` for the full rules.
 */
export interface EnrollmentListStats {
  /** @minimum 0 */
  total?: number;
  /** @minimum 0 */
  in_progress?: number;
  /** @minimum 0 */
  completed?: number;
  /** @minimum 0 */
  opened?: number;
  /** @minimum 0 */
  clicked?: number;
  /** @minimum 0 */
  interested?: number;
  /** @minimum 0 */
  not_interested?: number;
  /** @minimum 0 */
  bounced?: number;
  /** @minimum 0 */
  opted_out?: number;
}
